import { render, staticRenderFns } from "./TaskTypesItem.vue?vue&type=template&id=66388278&scoped=true"
import script from "./TaskTypesItem.vue?vue&type=script&lang=js"
export * from "./TaskTypesItem.vue?vue&type=script&lang=js"
import style0 from "./TaskTypesItem.vue?vue&type=style&index=0&id=66388278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66388278",
  null
  
)

export default component.exports